import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Constants } from '../constants';
import { UsersService } from './users.service';
import { FGAData } from '../fga/models';
@Injectable({
	providedIn: 'root'
})
export class GroupIStateService {

	private guidStateSource = new BehaviorSubject<string>('');
	guidState = this.guidStateSource.asObservable();
	private roleStateSource = new BehaviorSubject<string>('');
	roleState = this.roleStateSource.asObservable();
	private userInfoSource = new BehaviorSubject<string>('');
	userInfoState = this.userInfoSource.asObservable();
	public details$ = new BehaviorSubject<FGAData>(null);

	constructor(private readonly userService: UsersService, private readonly constants: Constants) { }

	getGUIDState() {
		return this.guidStateSource.getValue();
	}

	setGUIDState(name: string) {
		this.guidStateSource.next(name);
	}

	getroleState() {
		return this.roleStateSource.getValue();
	}
	setroleState(role: string) {
		this.roleStateSource.next(role);
	}

	getuserInfoState() {
		return this.userInfoSource.getValue();
	}

	setuserInfoState(value: string) {
		this.userInfoSource.next(value);
	}

	async getRoles() {
		const areRolesPresent = this.getroleState();
		if (!areRolesPresent) {
			if (!this.getGUIDState())
				{await new Promise(f => setTimeout(f, 2000));}
			await this.getUserInfo(localStorage.getItem('toyotaGUID')).then((x) => {
				console.info(`Valid User : ${x}`)
				if (!x)
					{window.location.replace(this.constants.LIOSMainPortalURL);}
			})
			// } else {
			// 	this.setroleState(areRolesPresent)
		}
	}

	async getUserInfo(toyotaGUID): Promise<boolean> {
		let isValidRole = false;
		await this.userService.getUserInfoFreeze(toyotaGUID).then(
			(result) => {
				if (result && result.length > 0) {
					const userInfo = result;
					const rolesArray = [];
					userInfo.forEach(e => {
						const roleName = e.strrole + String(e.logisticspoint ? "/" + e.logisticspoint : "")
						if (!rolesArray.includes(roleName))
							{rolesArray.push(roleName)}
					});
					if (rolesArray && rolesArray?.includes(this.constants.LIOS_UAC_Admin) || rolesArray?.includes(this.constants.LIOS_UAC_TaskManagerUser) || rolesArray?.includes(this.constants.LIOS_UAC_TaskManagerAdmin)) {
						isValidRole = true;
					}
					this.setroleState(JSON.stringify(rolesArray));
					this.setuserInfoState(JSON.stringify(userInfo[0]));
				}
			}, error => {
				console.info(error)
			});
		return isValidRole;
	}

	getDetails(): Observable<FGAData> {
		return this.details$.asObservable();
	  }
}